
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.182 9.143h5.09v1.143h-5.09V9.143zM3.182 6.286h7.636v1.142H3.182V6.286zM3.182 12h3.181v1.143H3.182V12z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.727 1.714h-1.909v-.571c0-.303-.134-.594-.373-.808a1.35 1.35 0 00-.9-.335h-5.09c-.338 0-.662.12-.9.335a1.087 1.087 0 00-.373.808v.571h-1.91c-.337 0-.66.12-.9.335A1.087 1.087 0 000 2.857v12c0 .303.134.594.373.808.238.215.562.335.9.335h11.454c.338 0 .662-.12.9-.335.239-.214.373-.505.373-.808v-12c0-.303-.134-.594-.373-.808a1.35 1.35 0 00-.9-.335zm-8.272-.571h5.09v2.286h-5.09V1.143zm8.272 13.714H1.273v-12h1.909v1.714h7.636V2.857h1.91v12z","fill":"currentColor"}})])
          )
        }
      }
    